import { connect } from "react-redux";
import DisplayActions from "../../../../redux/DisplayRedux";
import ChangeAdModal from "../components/detail/ChangeAdModal";

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  token: userAccount.token,
  currency: userAccount.currency,
  isSuperUser: userAccount.isSuperUser,
  libraryContents: display.libraryContents,
  loadingContentsbyCompany: display.loadingContentsbyCompany,
  defaultContent: display.defaultContent,
  brand: display.brand,
  currentCampaign: display.currentCampaign,
  statusNewContent: display.statusNewContent,
  fileCanvaNew: display.fileNew,
});

const mapStateToDispatch = (dispatch) => ({
  getContentsByCompany: (companyId, params) =>
    dispatch(DisplayActions.getContentsByCompanyRequest(companyId, params)),
  getContentsByUsers: (userId, params) =>
    dispatch(DisplayActions.getContentsByUsersRequest(userId, params)),
  setLibraryContents: (contents) =>
    dispatch(DisplayActions.setLibraryContents(contents)),
  updateDefaultContentRequest: (id) =>
    dispatch(DisplayActions.updateDefaultContentRequest(id)),
  setStatusNewContent: (statusNewContent) =>
    dispatch(DisplayActions.setStatusNewContent(statusNewContent)),
  updateRelationCampaignRequest: (content, relation, campaignId) =>
    dispatch(DisplayActions.updateRelationCampaignRequest(content, relation, campaignId)),
  updateContentDisplayByContent: (content, displayId) =>
    dispatch(DisplayActions.updateContentDisplayByContent(content, displayId)),
  changeProgrammaticContentRequest: (campaignId, params) =>
    dispatch(DisplayActions.changeProgrammaticContentRequest(campaignId, params)),
  getCampaign: (campaignId) => dispatch(DisplayActions.getCampaignRequest(campaignId)),
});

export default connect(mapStateToProps, mapStateToDispatch)(ChangeAdModal);
